var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-action-buttons" },
    _vm._l(_vm.actions, function (action, index) {
      return _c(
        "Button",
        {
          key: index,
          style: { marginRight: index < _vm.actions.length - 1 ? "5px" : "0" },
          attrs: { type: action.type, size: action.size, icon: action.icon },
          on: { click: action.onClick },
        },
        [_vm._v("\n        " + _vm._s(action.text) + "\n    ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }